var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public-content"},[_c('div',{attrs:{"id":"errorInfo"}},[_c('div',{staticClass:"code"},[_vm._v(_vm._s(_vm.code))]),_vm._v(" "),_c('div',{staticClass:"descrbe"},[_vm._v(_vm._s(_vm.describ))]),_vm._v(" "),_c('el-button',{staticClass:"minButton",attrs:{"size":"small"},on:{"click":_vm.goBack}},[_vm._v("返回首页")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-618c4012","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/error.vue
// module id = null
// module chunks = 